import { render, staticRenderFns } from "./EnacAtplDashboardPhaseLearnerFlat.vue?vue&type=template&id=20088c17"
import script from "./EnacAtplDashboardPhaseLearnerFlat.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseLearnerFlat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports